import styled from "styled-components";

export const Wrapper = styled.header`
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
  padding: 16px;
  background-color: ${(props) => props.theme.lightTheme.colors.darkGray};
`;
